import gql from 'graphql-tag'
import numeral from 'numeral'
import moment from 'moment'
import client from '@stores/apollo'
import { CostBuildingFragment } from './fragments'

interface Props {
  cost: string
  year: number
  buildingId: string
}

export default async function create({ cost, year, buildingId }: Props) {
  cost = numeral(cost).format('0.00')
  const date = `${year}-01-01`
  const startDate = moment.utc(date).startOf('year')
  const endDate = moment.utc(date).endOf('year')
  const variables = {
    input: {
      buildingId,
      cost,
      name: `Ops cost for ${year}`,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      type: 'OperationCost',
    },
  }
  await client.gql.mutate({ mutation, variables })
  const { building } = await getBuilding(buildingId, year)
  return building
}

export async function getBuilding(id: string, year: number) {
  const variables = {
    id,
    year,
  }
  const {
    data: { building },
  } = await client.gql.query({ query: buildingQuery, variables })
  return { building }
}

const mutation = gql`
  mutation createOpsCost($input: CreateContractInput!) {
    createContract(input: $input) {
      contract {
        id
      }
    }
  }
`

const buildingQuery = gql`
  query building($id: ID!, $year: Int!) {
    building: node(id: $id) {
      ...CostBuildingFragment
    }
  }
  ${CostBuildingFragment}
`
